import React, { Fragment, memo, useContext, useEffect } from "react";

import { addDays, addMonths, format } from 'date-fns';
import { PostApi503, PostApi551, PostApi554, PostApi555, PostApi556 } from "../../modules/network/padoPost";
// imageImport
import _hospital_img01 from "../../resources/images/main/hospital_img01.jpg";
import _hospital_img02 from "../../resources/images/main/hospital_img02.jpg";
import _hospital_img03 from "../../resources/images/main/hospital_img03.jpg";
import _hospital_img04 from "../../resources/images/main/hospital_img04.jpg";
import _hospital_img05 from "../../resources/images/main/hospital_img05.png";

import _edu_edu from "../../resources/images/main/edu_edu.png";
import _edu_img from "../../resources/images/main/edu_img.png";
import _edu_link from "../../resources/images/main/edu_link.png";
import _edu_mov from "../../resources/images/main/edu_mov.png";
import _edu_pdf from "../../resources/images/main/edu_pdf.png";

import IcTrtmtNew from "../../resources/images/icon/trtmtData/card/Icon_trtmt_new.svg";

import { AppContext, SET_PAGE_STATE, SocketCommand, socketManager } from "../../components/AppProvider";
import { _O } from "../../modules/utils";
import { MdEducoConnect } from "../../modules/utils/HandleWs";
import { IC } from "../../resources/Assets";
import _icon_video_file from "../../resources/images/icon/icon_video_file.png";
import { fileInfoToOBJ2 } from "../common/DownloadFile/DownloadFile";
import { NativeViewOpen } from "../common/NativeViewOpen/NativeViewOpen";
import { openLayerFn } from "../Layout";

const interfaceDateFormat = 'yyyyMMdd';

export const PeriodSetting = memo((props) => {
  const { setPeriodIndex } = props;

  const { dispatch, pageState } = useContext(AppContext);

  useEffect(() => {
    $(".date-setting-area .btns a").click(function () {
      $(".date-setting-area .btns a").removeClass("on");
      $(this).addClass("on");
      var idx = $(this).index();
      if (idx == 3) {
        //직접 기간설정
        $(".date-setting-area .date-input").slideDown("fast");
      } else {
        $(".date-setting-area .date-input").slideUp("fast");
      }

      // setPeriodIndex(idx);

      // 공유모드 초기화
      $("#confirmCheck").hide();
      $(".check-box").hide();
      $("input:checkbox").prop("checked", false);
      // setShareMode(0);
      dispatch({ type: SET_PAGE_STATE, data: { type: "share", state: 0 } });
    });
  }, []);
  return (
    <div className="date-setting-area">
      <div className="btns">
        <a onClick={() => setPeriodIndex(0)} style={{ height: "28px", lineHeight: "28px" }}>
          3개월
        </a>
        <a onClick={() => setPeriodIndex(1)} style={{ height: "28px", lineHeight: "28px" }}>
          6개월
        </a>
        <a
          onClick={() => setPeriodIndex(2)}
          style={{ height: "28px", lineHeight: "28px" }}
          className="on"
        >
          1년
        </a>
        <a
          onClick={() => setPeriodIndex(3)}
          style={{ height: "28px", lineHeight: "28px" }}
          className="btn-selfinput"
        >
          기간설정
        </a>
      </div>
      <div className="date-input">
        <div className="round-bar">
          <div className="ipbox">
            <input
              type="text"
              id="dateFrom"
              placeholder="선택하세요."
              readOnly
              className="date-picker-input pick-num1"
              data-num="1"
            />
            <i></i>
          </div>
          <u>~</u>
          <div className="ipbox">
            <input
              type="text"
              id="dateTo"
              placeholder="선택하세요."
              readOnly
              className="date-picker-input pick-num2"
              data-num="2"
            />
            <i></i>
          </div>
        </div>
      </div>
    </div>
  );
});

export const TrtmtPeriodSetting = memo((props) => {
  const { setPeriodIndex } = props;

  const { dispatch, pageState } = useContext(AppContext);

  useEffect(() => {
    $(".date-setting-area .btns a").click(function () {
      $(".date-setting-area .btns a").removeClass("on");
      $(this).addClass("on");
      var idx = $(this).index();
      if (idx == 3) {
        //직접 기간설정
        $(".date-setting-area .date-input").slideDown("fast");
      } else {
        $(".date-setting-area .date-input").slideUp("fast");
      }

      // setPeriodIndex(idx);

      // 공유모드 초기화
      $("#confirmCheck").hide();
      $(".check-box").hide();
      $("input:checkbox").prop("checked", false);
      // setShareMode(0);
      dispatch({ type: SET_PAGE_STATE, data: { type: "share", state: 0 } });
    });
  }, []);
  return (
    <div className="date-setting-area">
      <div className="btns">
        <a
          className="on"
          onClick={() => setPeriodIndex(0)}
          style={{ height: "28px", lineHeight: "28px" }}
        >
          1년
        </a>
        <a onClick={() => setPeriodIndex(1)} style={{ height: "28px", lineHeight: "28px" }}>
          2년
        </a>
        <a onClick={() => setPeriodIndex(2)} style={{ height: "28px", lineHeight: "28px" }}>
          3년
        </a>
        <a
          onClick={() => setPeriodIndex(3)}
          className="btn-selfinput"
          style={{ height: "28px", lineHeight: "28px" }}
        >
          기간설정
        </a>
      </div>
      <div className="date-input">
        <div className="round-bar">
          <div className="ipbox">
            <input
              type="text"
              id="dateFrom"
              placeholder="선택하세요."
              readOnly
              className="date-picker-input pick-num1"
              data-num="1"
            />
            <i></i>
          </div>
          <u>~</u>
          <div className="ipbox">
            <input
              type="text"
              id="dateTo"
              placeholder="선택하세요."
              readOnly
              className="date-picker-input pick-num2"
              data-num="2"
            />
            <i></i>
          </div>
        </div>
      </div>
    </div>
  );
});

export const SelectArea = (props) => { 
    const { show, hospitalList, modalityList, setHpCode, setModalityName, trgtHsptList } = props;
    const { pageState } = useContext(AppContext)

    const firstSelectBoxEvent = (e) => {
        $(e.target).closest(".select-gray-enable").find("a.btn-select").removeClass("gray");
        $(e.target).closest(".select-custom-box").removeClass("on");
        $(e.target).closest(".select-custom-box").find("a.btn-select").html($(e.target).html());

        if(pageState.share == 0) {
            setHpCode(e.target.name);
        } else {
            $("#targetHsptCd").val(e.target.name);
        }
    }
    
    const secondSelectBoxEvent = (e) => {
        $(e.target).closest(".select-gray-enable").find("a.btn-select").removeClass("gray");
        $(e.target).closest(".select-custom-box").removeClass("on");
        $(e.target).closest(".select-custom-box").find("a.btn-select").html($(e.target).html());

        if(pageState.share == 0) {
            setModalityName(e.target.name);
        } else {
            
        }
    }

    return(
        <Fragment>
            <div className="select-custom-box select-gray-enable">
                <a className="btn-select">병원 전체</a>
                <input type='hidden' id='targetHsptCd' value='' />
                <ul>
                    <li><a onClick={firstSelectBoxEvent}>병원 전체</a></li>

                    {
                        (hospitalList != null && hospitalList.length > 0) &&
                            hospitalList.map((m, i) => (
                                <SelectList hpCode={m.hpCode} hpName={m.hpName} firstSelectBoxEvent={firstSelectBoxEvent} key={i} />
                            ))
                    }
                </ul>
            </div>
            
            {!show &&(
                <div className="select-custom-box select-gray-enable" id="selectMaterial">
                    <a className="btn-select">자료 전체</a>
                    <ul>
                        <li><a onClick={secondSelectBoxEvent}>자료 전체</a></li>
                        {(modalityList != null && modalityList.length > 0) &&
                            modalityList.map((m) => (
                            <li key={m.modalityName}>
                                <a onClick={secondSelectBoxEvent} name={m.modalityName}>{m.modalityName}</a>
                            </li>
                        ))
                        }
                    </ul>
                </div>
            )}
            
        </Fragment>
    );
}

export const SelectList = (props) => {
    const { hpCode, hpName, firstSelectBoxEvent } = props;
    
    return(
        <li key={hpCode}>
            <a onClick={firstSelectBoxEvent} name={hpCode}>{hpName}</a>
        </li>
    )
}

export const getSearchDate = (param) => {
    let newDate = new Date();
    let day, month, year;


    if(param === 'WEEK') {
        newDate = new Date(Date.parse(new Date()) - parseInt(7) * 1000 * 60 * 60 * 24);
    }

    if(param === '1MONTH') {
        newDate = new Date(newDate.getFullYear() - parseInt(1 / 12), newDate.getMonth() - parseInt(1 % 12), newDate.getDate());
    }

    if(param === '3MONTH') {
        newDate = new Date(newDate.getFullYear() - parseInt(3 / 12), newDate.getMonth() - parseInt(3 % 12), newDate.getDate());
    }

    day = newDate.getDate();
    month = newDate.getMonth() + 1;
    year = newDate.getFullYear();

    day = day < 10 ? "0"+ day : day;
    month = month < 10 ? "0"+ month : month;

    return year + "" + month + "" + day;
}

export const ListView = memo((props) => {
    const { type, list, userToken, openConfirmLayer, returnUrl, reloadList, socketConnection, bizSubType } = props;

    return(
        <Fragment>
            {
                (list != null && list.length > 0) 
                    ? <ListViewData type={type} list={list} userToken={userToken} openConfirmLayer={openConfirmLayer} returnUrl={returnUrl} reloadList={reloadList} socketConnection={socketConnection} bizSubType={bizSubType} /> 
                    : <Nothing list={list}
                />}
        </Fragment>
    );
})

export const DayLabel = (props) => {
    const { listDate } = props;
    const week = new Array ("일", "월", "화", "수", "목", "금", "토");

    let year = listDate.substring(0,4);
    let month = listDate.substring(4,6);
    let date = listDate.substring(6,8);
    let hour = listDate.substring(8,10);
    let min = listDate.substring(10,12);

    let getDate = new Date(year + '-' + month + '-' + date).getDay();
    let day = week[getDate];

    return year + "." + month + "." + date + "(" + day + ") " + hour + ":" + min;
}

export const ListViewData = memo((props) => {
  const {
    type,
    list,
    userToken,
    openConfirmLayer,
    returnUrl,
    reloadList,
    socketConnection,
    bizSubType,
  } = props;
  const { userinfo, cfg, phonecfg, pageState } = useContext(AppContext);

  let thumnailImage;
  if (type === "VIDEO") {
    thumnailImage = _hospital_img01;
  }
  if (type === "INSFECTION") {
    thumnailImage = _hospital_img02;
  }
  if (type === "TREAT") {
    thumnailImage = _hospital_img03;
  }
  if (type === "MEDICAL") {
    thumnailImage = _hospital_img04;
  }

  const clickCheckEvent = (e, trsmId) => {
    let target = "img" + trsmId;
    if ($("img[name=" + target + "]").attr("class") == "longTap none") {
      $("img[name=" + target + "]").removeClass("none");
    } else {
      $("img[name=" + target + "]").addClass("none");
    }

    if (parseInt($(".longTap").length) === parseInt($(".none").length)) {
      $("#checkAll").hide();
      $("#unCheckAll").show();
    } else {
      $("#checkAll").show();
      $("#unCheckAll").hide();
    }
  };

  const goVideoPage = (modalityName, thumbNail, studyDesc, returnUrl) => {
    _O.Open(
      "/videoLink/" +
        encodeURIComponent(modalityName) +
        "/" +
        encodeURIComponent(thumbNail) +
        "/" +
        studyDesc +
        "/" +
        encodeURIComponent(returnUrl)
    );
  };

  const clickRowEvent = (
    e,
    trsmId,
    fileSeq,
    fileExt,
    fileSize,
    dnFileNm,
    dnYn,
    studyDesc,
    modalityName,
    bizType,
    thumbNail,
    hpName,
    groupNo
  ) => {
    if (pageState.share === 1) {
      if (e.target.className == "longTap none") {
        $(e.target).removeClass("none");
        $("#" + trsmId).prop("checked", false);
      } else {
        $(e.target).addClass("none");
        $("#" + trsmId).prop("checked", true);
      }
    } else {
      // phoneOs 구분
      if (phonecfg.phoneOS === "ANDROID") {
        if (
          fileExt == "mp4" ||
          fileExt == "MP4" ||
          fileExt == "avi" ||
          fileExt == "AVI" ||
          fileExt == "wmv" ||
          fileExt == "WMV" ||
          fileExt == "mkv" ||
          fileExt == "MKV"
        ) {
          if (parseInt(phonecfg.version.split(".")[2]) >= 100) {
            // socketConnection(trsmId, fileExt);
            commonFileUpload(
              reloadList,
              userinfo,
              trsmId,
              5,
              "Y",
              "PR",
              "개인진료기록",
              bizSubType
            );
          } else {
            commonFileUpload(
              reloadList,
              userinfo,
              trsmId,
              5,
              "Y",
              "PR",
              "개인진료기록",
              bizSubType
            );
          }
        } else if (fileExt == "edu") {
          MdEducoConnect(userinfo, phonecfg, cfg, studyDesc, 0, trsmId, reloadList);
        } else if (fileExt == "LINK" && groupNo == "1") {
          goVideoPage(modalityName, thumbNail, studyDesc, returnUrl);
        } else {
          if (parseInt(phonecfg.version.split(".")[2]) >= 100) {
            if (bizType === "PF") {
              commonFileUpload(
                reloadList,
                userinfo,
                trsmId,
                5,
                "Y",
                "PF",
                "제증명서류",
                bizSubType
              );
            } else {
              commonFileUpload(
                reloadList,
                userinfo,
                trsmId,
                5,
                "Y",
                "PR",
                "개인진료기록",
                bizSubType
              );
            }
          } else {
            commonFileUpload(
              reloadList,
              userinfo,
              trsmId,
              5,
              "Y",
              "PR",
              "개인진료기록",
              bizSubType
            );
          }
        }
      } else {
        if (
          fileExt == "mp4" ||
          fileExt == "MP4" ||
          fileExt == "avi" ||
          fileExt == "AVI" ||
          fileExt == "wmv" ||
          fileExt == "WMV" ||
          fileExt == "mkv" ||
          fileExt == "MKV"
        ) {
          commonFileUpload(reloadList, userinfo, trsmId, 5, "Y", "PR", "개인진료기록", bizSubType);
        } else if (fileExt == "edu") {
          MdEducoConnect(userinfo, phonecfg, cfg, studyDesc, 0, trsmId, reloadList);
        } else if (fileExt == "LINK" && groupNo == "1") {
          goVideoPage(modalityName, thumbNail, studyDesc, returnUrl);
        } else {
          if (parseInt(phonecfg.version.split(".")[2]) >= 10) {
            if (bizType === "PF") {
              commonFileUpload(
                reloadList,
                userinfo,
                trsmId,
                5,
                "Y",
                "PF",
                "제증명서류",
                bizSubType
              );
            } else {
              commonFileUpload(
                reloadList,
                userinfo,
                trsmId,
                5,
                "Y",
                "PR",
                "개인진료기록",
                bizSubType
              );
            }
          } else {
            commonFileUpload(
              reloadList,
              userinfo,
              trsmId,
              5,
              "Y",
              "PR",
              "개인진료기록",
              bizSubType
            );
          }
        }
      }
    }
  };

  useEffect(() => {
    $("#inputOk").hide();
  }, []);

  return (
    <div className="pr-section">
      <div className="hospi-boxes-contain">
        {list.map((m, i) =>
          pageState.share === 1
            ? m.modalityName != "mirabell_education" &&
              m.fileExt != "LINK" &&
              ResultList(m, clickCheckEvent, thumnailImage, clickRowEvent, openConfirmLayer)
            : ResultList(m, clickCheckEvent, thumnailImage, clickRowEvent, openConfirmLayer)
        )}
      </div>
    </div>
  );
});

export const BtnSharedMode = (props) => {
  const { shareMode, setShareMode, handleAlert } = props;

  const clickBtnEvent = () => {
    if (shareMode != 1) {
      $(".longTap").addClass("none");
      $("#confirmCheck").show();
      $(".check-box").show();
      setShareMode(1);
    } else {
      $(".longTap").removeClass("none");
      $("#confirmCheck").hide();
      $(".check-box").hide();
      $("input:checkbox").prop("checked", false);
      setShareMode(0);
    }
  };

  return (
    <div className="share-bot-box">
      <a
        className={shareMode != 1 ? "btnShared disabled" : "btnShared"}
        onClick={() => clickBtnEvent()}
      >
        타병원 공유
      </a>
    </div>
  );
};

export const BtnTypePill = (props) => {
  const { text, onClick, id, display } = props;

  const style = {
    display: "block",
    height: "28px",
    width: "72px",
    lineHeight: "28px",
    borderRadius: "16px",
    textAlign: "center",
    color: "#fff",
    fontSize: "13px",
    background: "#d1d8ef",
    marginLeft: "8px",
    float: "right",
  };

  const styleNone = {
    display: "none",
    height: "28px",
    width: "72px",
    lineHeight: "28px",
    borderRadius: "16px",
    textAlign: "center",
    color: "#fff",
    fontSize: "13px",
    background: "#d1d8ef",
    marginLeft: "8px",
    float: "right",
  };

  return (
    <a style={!display ? style : styleNone} onClick={onClick} id={id}>
      {text}
    </a>
  );
};

export const PillBtnArea = (props) => {
  const { children } = props;

  const style = {
    padding: "0px 20px",
  };

  return <div style={style}>{children}</div>;
};

export const Nothing = (props) => {
  const list = props;

  useEffect(() => {
    if (!list.length > 0) {
      $("#inputOk").show();
    }
  }, []);

  return (
    <div className="nothing-box">
      <div>
        <img src={_icon_video_file} alt="" />
        <p>
          공유된 자료가 없습니다.
          <br />
          개인진료기록 보관방법을 확인해주세요.
        </p>
      </div>
    </div>
  );
};

// msgCount 가져오기
export const checkMsgCount = (
  userinfo,
  cfg,
  phonecfg,
  periodIndex,
  startDate,
  endDate,
  setList
) => {
  // const {  userinfo, cfg, phonecfg  } = useContext(AppContext);
  let reqStartDate = "";
  let reqEndDate = format(new Date(), interfaceDateFormat);
  switch (parseInt(periodIndex)) {
    case 0:
      reqStartDate = format(addDays(new Date(), -6), interfaceDateFormat);
      break;
    case 1:
      reqStartDate = format(addMonths(new Date(), -1), interfaceDateFormat);
      break;
    case 2:
      reqStartDate = format(addMonths(new Date(), -3), interfaceDateFormat);
      break;
    case 9:
      reqStartDate = format(addDays(new Date(), -14), interfaceDateFormat);
      break;
    default:
      reqStartDate = startDate;
      reqEndDate = endDate;
      break;
  }
  if (reqStartDate != "" && reqEndDate != "" && reqStartDate <= reqEndDate) {
    PostApi551(userinfo, cfg, phonecfg, "", "", reqStartDate, reqEndDate, "1", "Y", 1, 999)
      .then((res) => {
        if (res.resultMsg === "SUCCESS") setList(res.totRow);
      })
      .catch((err) => {
        console.log(err);
      });
  }
};

export const fileDelete = (userinfo, trsmId) => {
  commonFileDelete(null, userinfo, trsmId, 5, "Y", "PR", "개인진료기록");
};

export const request503 = (
  userinfo,
  cfg,
  phonecfg,
  trsmId,
  periodIndex,
  hpCode,
  modalityName,
  startDate,
  endDate,
  pdhType,
  downFlag,
  setList
) => {
  PostApi503(userinfo, cfg, phonecfg, trsmId)
    .then((res) => {
      if (res.resultMsg === "SUCCESS") {
        // list 초기화
        // setList(res.resultList);
        request551(
          userinfo,
          cfg,
          phonecfg,
          periodIndex,
          hpCode,
          modalityName,
          startDate,
          endDate,
          pdhType,
          downFlag,
          setList
        );
      }
    })
    .catch((err) => {
      console.log(err);
    });
};

// 자료 리스트 가져오기
export const request551 = (
  userinfo,
  cfg,
  phonecfg,
  periodIndex,
  hpCode,
  modalityName,
  startDate,
  endDate,
  pdhType,
  downFlag,
  setList
) => {
  let reqStartDate = "";
  let reqEndDate = format(new Date(), interfaceDateFormat);

  switch (parseInt(periodIndex)) {
    case 0:
      reqStartDate = format(addMonths(new Date(), -3), interfaceDateFormat);
      break;
    case 1:
      reqStartDate = format(addMonths(new Date(), -6), interfaceDateFormat);
      break;
    case 2:
      reqStartDate = format(addMonths(new Date(), -12), interfaceDateFormat);
      break;
    case 9:
      reqStartDate = format(addDays(new Date(), -14), interfaceDateFormat);
      break;
    default:
      reqStartDate = startDate;
      reqEndDate = endDate;
      break;
  }

  if (reqStartDate != "" && reqEndDate != "" && reqStartDate <= reqEndDate) {
    PostApi551(
      userinfo,
      cfg,
      phonecfg,
      hpCode,
      modalityName,
      reqStartDate,
      reqEndDate,
      pdhType,
      downFlag,
      1,
      999
    )
      .then((res) => {
        if (res.resultMsg === "SUCCESS") {
          setList(res.resultList);
        } else if (res.resiltMsg === "LOGOUT") {
          openLayerFn($(".alert-layer-logout"));
        }
      })
      .catch((err) => {
        console.log(err);
      });
  } else {
    setList(null);
  }
};

// 병원명 가져오기
export const request554 = (
  userinfo,
  cfg,
  phonecfg,
  periodIndex,
  startDate,
  endDate,
  pdhType,
  setList
) => {
  //const {  userinfo, cfg, phonecfg  } = useContext(AppContext);
  let reqStartDate = "";
  let reqEndDate = format(new Date(), interfaceDateFormat);
  switch (parseInt(periodIndex)) {
    case 0:
      reqStartDate = format(addMonths(new Date(), -3), interfaceDateFormat);
      break;
    case 1:
      reqStartDate = format(addMonths(new Date(), -6), interfaceDateFormat);
      break;
    case 2:
      reqStartDate = format(addMonths(new Date(), -12), interfaceDateFormat);
      break;
    default:
      reqStartDate = startDate;
      reqEndDate = endDate;
      break;
  }

  if (reqStartDate != "" && reqEndDate != "" && reqStartDate <= reqEndDate) {
    PostApi554(userinfo, cfg, phonecfg, pdhType, reqStartDate, reqEndDate)
      .then((res) => {
        if (res.resultMsg === "SUCCESS") setList(res.resultList);
      })
      .catch((err) => {
        console.log(err);
      });
  }
};

// 장비명 가져오기
export const request555 = (
  userinfo,
  cfg,
  phonecfg,
  periodIndex,
  startDate,
  endDate,
  pdhType,
  setList
) => {
  //const {  userinfo, cfg, phonecfg  } = useContext(AppContext);
  let reqStartDate = "";
  let reqEndDate = format(new Date(), interfaceDateFormat);
  switch (parseInt(periodIndex)) {
    case 0:
      reqStartDate = format(addMonths(new Date(), -3), interfaceDateFormat);
      break;
    case 1:
      reqStartDate = format(addMonths(new Date(), -6), interfaceDateFormat);
      break;
    case 2:
      reqStartDate = format(addMonths(new Date(), -12), interfaceDateFormat);
      break;
    default:
      reqStartDate = startDate;
      reqEndDate = endDate;
      break;
  }

  if (reqStartDate != "" && reqEndDate != "" && reqStartDate <= reqEndDate) {
    PostApi555(userinfo, cfg, phonecfg, pdhType, reqStartDate, reqEndDate)
      .then((res) => {
        if (res.resultMsg === "SUCCESS") setList(res.resultList);
      })
      .catch((err) => {
        console.log(err);
      });
  }
};

export const request556 = (userinfo, cfg, phonecfg, trsmId) => {
  PostApi556(userinfo, cfg, phonecfg, trsmId)
    .then((res) => {
      if (res.resultMsg === "SUCCESS") {
        console.log("webSocket POST PARAM ::", fileInfoToOBJ2(res.resultList));
        // if(res.resultList.length > 0) {
        //     // native 통신
        //     request503(userinfo, cfg,phonecfg, trsmId);
        // } else {
        //     console.log("LIST DELETE INTERFACE");
        // }
      }
    })
    .catch((err) => {
      console.log(err);
    });
};

function ResultList(m, clickCheckEvent, thumnailImage, clickRowEvent, openConfirmLayer, shareMode) {
  const { pageState } = useContext(AppContext);
  const deleteStyle = {
    display: "inline-block",
    verticalAlign: "middle",
    width: "20px",
    height: "20px",
    background: "url(" + IC.delete.IC_DELETE_GRAY + ") no-repeat center",
    backgroundSize: "contain",
    // , "margin":"0 4px 2px 0"
    marginTop: "-6px",
    float: "right",
  };

  let divStyle = { height: "35.93vw" };

  const fileExtCheck = (fileExt) => {
    if (fileExt === "edu") {
      return _edu_edu;
    } else if (fileExt === "jpg" || fileExt === "jpeg" || fileExt === "png" || fileExt === "gif") {
      return _edu_img;
    } else if (fileExt === "pdf") {
      return _edu_pdf;
    } else if (fileExt === "mp4") {
      return _edu_mov;
    } else if (fileExt === "LINK" || fileExt === "link") {
      return _edu_link;
    } else {
      return _edu_link;
    }
  };

  const supportFileCheck = (fileExt) => {
    if (fileExt === "edu") {
      return true;
    } else if (fileExt === "jpg" || fileExt === "jpeg" || fileExt === "png" || fileExt === "gif") {
      return true;
    } else if (fileExt === "pdf") {
      return true;
    } else if (fileExt === "mp4") {
      return true;
    } else if (fileExt === "LINK" || fileExt === "link") {
      return true;
    } else {
      return false;
    }
  };

  const nowYear = new Date().getFullYear();

  return (
    <>
      {supportFileCheck(m.fileExt) && (
        <div key={m.trsmId} className="contentsBox">
          <a>
            <div className="imgbox">
              <EduComponent
                imgSrc={fileExtCheck(m.fileExt)}
                clickRowEvent={clickRowEvent}
                m={m}
              />
              <label className="check-box2" style={{ display: "none" }}>
                <input
                  type="checkbox"
                  name="targetCheck"
                  value={m.trsmId}
                  id={m.trsmId}
                  onClick={e => clickCheckEvent(e, m.trsmId)}
                />
                <i></i>
              </label>
            </div>

            <div className="info" style={{ padding: "7px 7px" }}>
              <div style={{ display: "flex" }}>
                {m.newYn == "Y" && (
                  <img src={IcTrtmtNew} style={{ paddingRight: "5px" }} />
                )}
                <p>
                  {m.fileExt != "edu"
                    ? m.studyDesc
                    : "법정교육" + "[" + nowYear + "]"}
                </p>
              </div>
              <span style={{ paddingBottom: "1px" }}>{m.hpName}</span>
              <u>
                {m.fileExt != "edu" && <DayLabel listDate={m.cDate} />}

                {m.fileExt != "edu" &&
                  m.fileExt != "LINK" &&
                  pageState.share === 0 && (
                    <i
                      style={deleteStyle}
                      onClick={() => openConfirmLayer(m.trsmId)}
                    />
                  )}
              </u>
            </div>
          </a>
        </div>
      )}
    </>
  );
}

const EduComponent = ({ imgSrc, clickRowEvent, m }) => {
  const { phonecfg } = useContext(AppContext);
  let imgStyle = { height: "100%", width: "100%" };

  const onClickPacsLink = () => {
    NativeViewOpen(phonecfg.phoneOS, "https://smartstore.naver.com/mdpharmer/products/5533533271");
  };

  return (
    <img
      src={m.thumbnail ? m.thumbnail : imgSrc}
      className="longTap"
      style={imgStyle}
      name={"img" + m.trsmId}
      alt=""
      // onClick={(e) => clickRowEvent(e, m.trsmId, m.fileSeq, m.fileExt, m.fileSize, m.dnFileNm, m.dnYn, m.studyDesc, m.modalityName, m.bizType, m.thumbnail)}
      // onClick={(e) => clickRowEvent(e, m.trsmId, m.fileSeq, m.fileExt, m.fileSize, m.dnFileNm, m.dnYn, m.drName, m.modalityName, m.bizType, m.thumbnail)}
      onClick={
        m.fileExt === "edu"
          ? (e) =>
              clickRowEvent(
                e,
                m.trsmId,
                m.fileSeq,
                m.fileExt,
                m.fileSize,
                m.dnFileNm,
                m.dnYn,
                m.studyDesc,
                m.modalityName,
                m.bizType,
                m.thumbnail,
                m.groupNo
              )
          : (m.fileExt === "link" || m.fileExt === "LINK") && m.groupNo === "2"
          ? (e) => NativeViewOpen(phonecfg.phoneOS, m.modalityName)
          : (e) =>
              clickRowEvent(
                e,
                m.trsmId,
                m.fileSeq,
                m.fileExt,
                m.fileSize,
                m.dnFileNm,
                m.dnYn,
                m.drName,
                m.modalityName,
                m.bizType,
                m.thumbnail,
                m.hpName,
                m.groupNo
              )
      }
    />
  );
};

const ImageVideo = (m, clickCheckEvent, clickRowEvent, thumnailImage) => {
  const divStyle = { height: "49.93vw" };
  const imgStyle = { top: "50%", transform: "translateY(50%)" };

  return (
    <div className="imgbox" style={divStyle}>
      <img
        src={m.thumbnail}
        className="longTap"
        style={imgStyle}
        name={"img" + m.trsmId}
        alt=""
        onClick={(e) =>
          clickRowEvent(
            e,
            m.trsmId,
            m.fileSeq,
            m.fileExt,
            m.fileSize,
            m.dnFileNm,
            m.dnYn,
            m.studyDesc,
            m.modalityName
          )
        }
      />

      <label className="check-box2" style={{ display: "none" }}>
        <input
          type="checkbox"
          name="targetCheck"
          value={m.trsmId}
          id={m.trsmId}
          onClick={(e) => clickCheckEvent(e, m.trsmId)}
        />
        <i></i>
      </label>

      {m.fileExt != "edu" && m.fileExt != "LINK" && (
        <div className="imgcount">
          <i></i>
          {m.filecnt}
        </div>
      )}
    </div>
  );
};

const ImageEtc = (m, clickCheckEvent, clickRowEvent, thumnailImage) => {
  const divStyle = { height: "49.93vw" };
  const imgStyle = { height: "49.93vw" };

  return (
    <div className="imgbox" style={divStyle}>
      <img
        src={
          m.fileExt === "edu" ? _hospital_img05 : m.fileExt === "LINK" ? m.thumbnail : thumnailImage
        }
        className="longTap"
        style={imgStyle}
        name={"img" + m.trsmId}
        alt=""
        onClick={(e) =>
          clickRowEvent(
            e,
            m.trsmId,
            m.fileSeq,
            m.fileExt,
            m.fileSize,
            m.dnFileNm,
            m.dnYn,
            m.studyDesc,
            m.modalityName
          )
        }
      />

      <label className="check-box2" style={{ display: "none" }}>
        <input
          type="checkbox"
          name="targetCheck"
          value={m.trsmId}
          id={m.trsmId}
          onClick={(e) => clickCheckEvent(e, m.trsmId)}
        />
        <i></i>
      </label>

      {m.fileExt != "edu" && m.fileExt != "LINK" && (
        <div className="imgcount">
          <i></i>
          {m.filecnt}
        </div>
      )}
    </div>
  );
};

export const commonFileUpload = (
  reloadList,
  userinfo,
  trsmId,
  bizDtlType,
  view,
  bizType,
  bizName,
  bizSubType,
  redirectUrl
) => {
  // masterKey1 : seqNo(key) masterKey2 : type
  // masterKey2 = paperFlag.toString() === "0" ? "P" : "E";
  let masterKey1 = "";
  let masterKey2 = "";
  let masterKey3 = "";

  masterKey1 = trsmId.toString().split("!")[0];

  if (trsmId.toString().split("!")[1]) {
    masterKey2 = trsmId.toString().split("!")[1];
  }

  if (view === "Y") {
    socketManager(SocketCommand.FILE_UPLOAD, reloadList, {
      type: "download",
      userToken: userinfo.userToken,
      masterKeys: [
        {
          masterKey1: masterKey1,
          masterKey2: masterKey2,
          masterKey3: masterKey3,
        },
      ],
      bizType: bizType,
      bizName: bizName,
      bizDtlType: bizDtlType.toString(),
      viewYN: "Y",
      saveExtYN: "N",
      redirectURL: "cnntHspt/1",
      colorType: "PP",
      hsptSharYn: "Y",
      bizSubType: bizSubType,
    });
  } else {
    socketManager(SocketCommand.FILE_UPLOAD, reloadList, {
      type: "download",
      userToken: userinfo.userToken,
      masterKeys: [
        {
          masterKey1: masterKey1,
          masterKey2: masterKey2,
          masterKey3: masterKey3,
        },
      ],
      bizType: bizType,
      bizName: bizName,
      bizDtlType: bizDtlType.toString(),
      viewYN: "N",
      saveExtYN: "N",
      redirectURL: "cnntHspt/1",
      colorType: "PP",
      hsptSharYn: "Y",
      bizSubType: "",
    });
  }
};

export const commonFileDelete = (reloadList, userinfo, trsmId, bizDtlType, view, bizType, bizName) => {
    let masterKey1 = "";
    let masterKey2 = "";

    masterKey1 = trsmId.toString().split("!")[0];

    if(trsmId.toString().split("!")[1]) {
        masterKey2 = trsmId.toString().split("!")[1];
    }

    socketManager(SocketCommand.FILE_UPLOAD, reloadList, {
      type: "delete",
      userToken: userinfo.userToken,
      masterKeys: [
        {
          masterKey1: masterKey1,
          masterKey2: masterKey2,
        },
      ],
      bizType: bizType,
      bizName: bizName,
      bizDtlType: bizDtlType.toString(),
      viewYN: "N",
      saveExtYN: "N",
      redirectURL: "cnntHspt/1",
      colorType: "PP",
      hsptSharYn: "Y",
    });
}